"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _index = require("../../../../../../index");

var _UserModel = _interopRequireDefault(require("../../../models/UserModel"));

var _CardPreview = _interopRequireDefault(require("../../../../../cards/components/CardPreview"));

var _CardModel = _interopRequireDefault(require("../../../../../../modules/cards/models/CardModel"));

var _ModalDialog = _interopRequireDefault(require("../../../../../../components/modal/ModalDialog"));

var _NumberHelper = _interopRequireDefault(require("../../../../../../util/NumberHelper"));

var _components = require("../../../../../../components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UserCards = /*#__PURE__*/function (_React$Component) {
  _inherits(UserCards, _React$Component);

  function UserCards(props) {
    var _this;

    _classCallCheck(this, UserCards);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserCards).call(this, props));
    _this.state = {
      loading: false,
      showStolenModal: false
    };
    return _this;
  }

  _createClass(UserCards, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement(_index.AppFetcher, {
        ref: function ref(fetcher) {
          return _this2._fetcher = fetcher;
        },
        fetchWith: function fetchWith() {
          return new _UserModel["default"]().getCards(_this2.props.user.id);
        },
        renderContent: function renderContent(results) {
          return _this2._renderContent(results);
        }
      });
    }
  }, {
    key: "_changeCardLockStatus",
    value: function _changeCardLockStatus(card, val) {
      var _this3 = this;

      this.setState({
        loading: card.id
      });
      new _CardModel["default"]().changeFreezeStatus(card, val).then(function () {
        _this3.setState({
          loading: false
        });

        _this3._fetcher.refresh();
      })["catch"](function () {});
    }
  }, {
    key: "_changeStolenStatus",
    value: function () {
      var _changeStolenStatus2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(card) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _CardModel["default"]().changeStolenStatus(card);

              case 2:
                this.onClose();

                this._fetcher.refresh();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _changeStolenStatus(_x) {
        return _changeStolenStatus2.apply(this, arguments);
      }

      return _changeStolenStatus;
    }()
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        showStolenModal: false
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.setState({
        showStolenModal: true
      });
    }
  }, {
    key: "_renderContent",
    value: function _renderContent(results) {
      var _this4 = this;

      var user = this.props.user;
      var items = [];
      results.forEach(function (element, index) {
        var title = element.type === 'virtual' ? 'Virtual Card' : 'Physical card';
        var status = 'ACTIVE';

        switch (element.status) {
          case 'pending_activation':
            status = 'PENDING ACTIVATION';
            break;

          case 'active':
            status = 'ACTIVE';
            break;

          case 'locked':
            status = 'LOCKED';
            break;

          case 'stolen':
            status = 'STOLEN';
            break;
        }

        if (element.locked) {
          status = 'LOCKED';
        }

        var lockedOverlay = _react["default"].createElement("div", {
          className: "lockedOverlay"
        }, status === 'LOCKED' ? _react["default"].createElement("h3", null, "Card is locked!") : null, status === 'STOLEN' ? _react["default"].createElement("h3", null, "Card is stolen!") : null);

        var balance = element.balance;
        var pan = element.pan;
        var formatPan = pan.match(/.{1,4}/g);
        var newFormatPan = formatPan[0] + ' ' + formatPan[1] + ' ' + formatPan[2] + ' ' + formatPan[3];
        items.push(_react["default"].createElement("div", {
          key: 'card' + index,
          className: "col-md-7",
          style: {
            marginBottom: 20
          }
        }, _react["default"].createElement("div", {
          className: "element-with-blur"
        }, _react["default"].createElement("div", {
          className: "dark-blur"
        }), _react["default"].createElement("div", {
          className: "box-header marginless"
        }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
          className: "fa fa-credit-card",
          "aria-hidden": "true"
        }, " "), "  ", title)), _react["default"].createElement("div", {
          className: "box-body text-white padded"
        }, _this4.state.loading && _this4.state.loading == element.id ? _react["default"].createElement(_index.LoadingOverlay, null) : null, _react["default"].createElement("div", {
          className: "container"
        }, _react["default"].createElement("div", {
          className: "row"
        }, _react["default"].createElement("div", {
          className: "col-xl-7 cardHolder"
        }, _react["default"].createElement("div", {
          style: {
            position: 'realtive',
            maxWidth: 500
          }
        }, _react["default"].createElement(_CardPreview["default"], {
          card: element
        }), status === 'LOCKED' || status === 'STOLEN' ? lockedOverlay : null)), _react["default"].createElement("div", {
          className: "col-xl-5"
        }, _react["default"].createElement("p", null, "Cardholder Name: ", user.fullName), _react["default"].createElement("p", {
          className: "panNum"
        }, "PAN: ", newFormatPan), _react["default"].createElement("p", null, "Expiration: ", element.expires == null ? ' / ' : element.expires), _react["default"].createElement("p", null, "Balance: ", _NumberHelper["default"].currency(balance, user.currency)), _react["default"].createElement("p", null, "Status: ", status), status === 'STOLEN' ? null : _react["default"].createElement("div", {
          className: "lockCardWrapper"
        }, _react["default"].createElement("p", {
          style: {
            margin: 0
          }
        }, "Lock Card:"), _react["default"].createElement(_index.SwitchButton, {
          onChange: function onChange(val) {
            return _this4._changeCardLockStatus(element, val);
          },
          isChecked: !!element.locked
        }))))), _react["default"].createElement("div", {
          style: {
            marginTop: 20,
            textAlign: 'center'
          }
        }, _react["default"].createElement(_reactRouterDom.Link, {
          to: "/cards/details/".concat(element.id),
          className: "button-info"
        }, "Details"), status === 'STOLEN' ? null : _react["default"].createElement("span", null)))), _react["default"].createElement(_ModalDialog["default"], {
          show: _this4.state.showStolenModal,
          onClose: _this4.onClose.bind(_this4)
        }, _react["default"].createElement("div", {
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }
        }, _react["default"].createElement("p", {
          style: {
            textAlign: 'center',
            paddingBottom: 20
          }
        }, "Are you sure you wish to report this card as stolen?"), _react["default"].createElement("div", {
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }, _react["default"].createElement("button", {
          onClick: _this4.onClose.bind(_this4),
          className: "button-info"
        }, "NO"), _react["default"].createElement("button", {
          onClick: function onClick() {
            return _this4._changeStolenStatus(element);
          },
          className: "button-info"
        }, "YES"))))));
      });
      var content = items; //if there is no card, add order card button

      if (items.length === 0) {
        content = _react["default"].createElement(_components.LPOverridable, {
          name: "user.details.orderCard",
          cards: results,
          user: user,
          refresh: function refresh() {
            _this4._fetcher.refresh();
          }
        });
      }

      return _react["default"].createElement("div", null, content);
    }
  }]);

  return UserCards;
}(_react["default"].Component);

exports["default"] = UserCards;